import React from 'react';
import { Box, makeStyles, Typography } from 'housecall-ui';

import { OnlineBookingCard } from './OnlineBookingCard';

type Props = {
  title: string;
  description: string;
  onClick?: () => void;
};

const useStyles = makeStyles(() => ({
  truncateText: {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
}));

export const CategoryCard = ({ title, description, onClick }: Props) => {
  const { truncateText } = useStyles();

  return (
    <OnlineBookingCard onClick={onClick}>
      <Box p={2}>
        <Typography gutterBottom variant="subtitle2">
          {title}
        </Typography>
        <Typography className={truncateText} variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>
    </OnlineBookingCard>
  );
};
